<template>
  <v-card
    color="grey darken-3"
    dark
  >
    <v-card-text>
      <avatar />
      <div class="text-sm-center mb-4 mt-3">
        <h1>
          <span class="light-blue--text text--lighten-3">Frédéric Salgado</span>
        </h1>
        <span>
          Développement et support
        </span>
      </div>

      <sidebar-section :options="sections.info" />
      <!-- <sidebar-section :options="sections.socials" /> -->
      <sidebar-section :options="sections.hobbies">
        <template v-slot:item="{item}">
          <v-chip>
            <v-avatar>
              <v-icon>
                {{ item.icon }}
              </v-icon>
            </v-avatar>
            {{ item.text }}
          </v-chip>
        </template>
      </sidebar-section>
      <sidebar-section :options="sections.languages">
        <template v-slot:items="{items}">
          <v-container pa-0>
            <v-layout
              wrap
              class="text-xs-center"
            >
              <template
                v-for="(item, i) in items"
              >
                <v-flex
                  :key="i"
                  sm4
                  xs6
                >
                  <!-- md3 -->
                  <v-progress-circular
                    rotate="360"
                    size="65"
                    width="2"
                    :value="item.value"
                    color="white"
                    class="ma-4"
                  >
                    {{ item.text }}
                  </v-progress-circular>
                </v-flex>
              </template>
            </v-layout>
          </v-container>
        </template>
      </sidebar-section>
    </v-card-text>
  </v-card>
</template>

<script>
import Avatar from '@/views/dark-template/sidebar/Avatar'
import SidebarSection from '@/views/dark-template/sidebar/Section'
export default {
  name      : 'Sidebar',
  components: { SidebarSection, Avatar },
  data () {
    return {
      sections: {
        info: {
          title: 'Info',
          items: [
            {
              name: 'Email',
              icon: 'mdi-email',
              text: 'freds@hotmail.fr',
            },
            {
              name: 'Website',
              icon: 'mdi-web',
              text: 'sf.fr',
            },
            {
              name: 'Année de naissance',
              icon: 'mdi-cake-variant',
              text: '1979',
            },
            {
              name: 'Adresse',
              icon: 'mdi-map-marker',
              text: 'Tourcoing, Nord',
            },
          ],
        },
        hobbies: {
          title: 'Centres d\'intérêt',
          items: [
            {
              icon: 'mdi-walk',
              text: 'Marche/footing',
            },
            {
              icon: 'mdi-music',
              text: 'Musique',
            },
            {
              icon: 'mdi-image-filter-hdr',
              text: 'Voyages',
            },
            {
              icon: 'mdi-jabber',
              text: 'Bricolage',
            },
            {
              icon: 'mdi-magnet-on',
              text: 'Sciences',
            },
            {
              icon: 'mdi-auto-fix',
              text: 'IOT',
            },
            {
              icon: 'mdi-book-open-page-variant',
              text: 'Actus techniques',
            },
            {
              icon: 'mdi-teach',
              text: 'Accessibilité',
            },
            {
              icon: 'mdi-web',
              text: 'Web',
            },
            {
              icon: 'mdi-android-debug-bridge',
              text: 'Chasse aux bugs',
            },
          ],
        },
        languages: {
          title: 'Langues',
          items: [
            {
              text : 'Français',
              value: 92,
            },
            {
              text : 'Anglais',
              value: 65,
            },
            {
              text : 'Portugais',
              value: 55,
            },
          ],
        },
      },
    }
  },
}
</script>

<style scoped>
.sidebar{
    background: #2e2e2e;
}
</style>
